const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const QuestBoostAdd = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/boost/view/add.vue');
const QuestBoostEdit = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/boost/view/edit.vue');
const QuestBoostDetail = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/boost/view/detail.vue');
const QuestBoostList = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/boost/view/index.vue');
const QuestBoostTranslate = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/boost/view/translate.vue');
const QuestItemAdd = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/item/view/add.vue');
const QuestItemEdit = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/item/view/edit.vue');
const QuestItemList = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/item/view/index.vue');
const QuestItemTime = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/item/view/time.vue');
const QuestItemTranslate = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/item/view/translate.vue');
const QuestTypeAdd = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/type/view/add.vue');
const QuestTypeDetail = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/type/view/detail.vue');
const QuestTypeList = () => import(/* webpackChunkName: "quest" */ '@/modules/quest/type/view/index.vue');

export const ROUTE_NAME_QUEST = {
    BOOST: {
        INDEX: 'QuestBoostList',
        ADD: 'QuestBoostAdd',
        EDIT: 'QuestBoostEdit',
        DETAIL: 'QuestBoostDetail',
        TRANSLATE: 'QuestBoostTranslate'
    },
    ITEM: {
        INDEX: 'QuestItemList',
        ADD: 'QuestItemAdd',
        EDIT: 'QuestItemEdit',
        TIME: 'QuestItemTime',
        TRANSLATE: 'QuestItemTranslate'
    },
    TYPE: {
        INDEX: 'QuestTypeList',
        ADD: 'QuestTypeAdd',
        DETAIL: 'QuestTypeDetail'
    }
} as const;

export default [
    {
        path: '/app/:appId/quest/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'boost/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_QUEST.BOOST.INDEX,
                        component: QuestBoostList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_QUEST.BOOST.ADD,
                        component: QuestBoostAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':boostId/edit',
                        name: ROUTE_NAME_QUEST.BOOST.EDIT,
                        component: QuestBoostEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':boostId/detail',
                        name: ROUTE_NAME_QUEST.BOOST.DETAIL,
                        component: QuestBoostDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':boostId/translate',
                        name: ROUTE_NAME_QUEST.BOOST.TRANSLATE,
                        component: QuestBoostTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'item/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_QUEST.ITEM.INDEX,
                        component: QuestItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_QUEST.ITEM.ADD,
                        component: QuestItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':itemId/edit',
                        name: ROUTE_NAME_QUEST.ITEM.EDIT,
                        component: QuestItemEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':itemId/time',
                        name: ROUTE_NAME_QUEST.ITEM.TIME,
                        component: QuestItemTime,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':itemId/translate',
                        name: ROUTE_NAME_QUEST.ITEM.TRANSLATE,
                        component: QuestItemTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'type/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_QUEST.TYPE.INDEX,
                        component: QuestTypeList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_QUEST.TYPE.ADD,
                        component: QuestTypeAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':typeId/detail',
                        name: ROUTE_NAME_QUEST.TYPE.DETAIL,
                        component: QuestTypeDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
